import { useMemo } from "react";
import { useMetrics } from "hooks/useMetrics";
const LICENSE_VIOLATION_METRIC = "org.graylog.enterprise.license.status.violated";
const LICENSE_EXPIRATION_METRIC = "org.graylog.enterprise.license.status.expired";
const LICENSE_EXPIRATION_UPCOMING_METRIC = "org.graylog.enterprise.license.status.expiration-upcoming";
const LICENSE_TRIAL_METRIC = "org.graylog.enterprise.license.status.trial";
const LICENSE_TRAFFIC_VIOLATION_UPCOMING_METRIC = "org.graylog.enterprise.license.traffic.violation-upcoming";
const LICENSE_USAGE_THRESHOLD_METRIC = "org.graylog.enterprise.license.status.trafficThreshold";
const LICENSE_METRICS = [
  LICENSE_VIOLATION_METRIC,
  LICENSE_EXPIRATION_METRIC,
  LICENSE_EXPIRATION_UPCOMING_METRIC,
  LICENSE_TRIAL_METRIC,
  LICENSE_TRAFFIC_VIOLATION_UPCOMING_METRIC,
  LICENSE_USAGE_THRESHOLD_METRIC
];
const DEFAULT_STATUS = {
  violated: false,
  expired: false,
  expiredSince: 0,
  expirationUpcoming: false,
  expiresIn: 0,
  trial: false,
  trialExpiresIn: 0,
  trafficViolation: false
};
const useLicenseStatus = () => {
  const { data: metrics } = useMetrics(LICENSE_METRICS);
  return useMemo(() => {
    if (!metrics || Object.keys(metrics).length === 0) {
      return DEFAULT_STATUS;
    }
    const licenseStatus = { ...DEFAULT_STATUS };
    Object.keys(metrics).forEach((nodeId) => {
      Object.keys(metrics[nodeId]).filter((metricName) => LICENSE_METRICS.includes(metricName)).forEach((metricName) => {
        const metricValue = metrics[nodeId][metricName].metric;
        const value = metricValue && "value" in metricValue ? metricValue.value : 0;
        switch (metricName) {
          case LICENSE_VIOLATION_METRIC:
            licenseStatus.violated = value > 0;
            break;
          case LICENSE_EXPIRATION_METRIC:
            licenseStatus.expired = value > 0;
            licenseStatus.expiredSince = value;
            break;
          case LICENSE_EXPIRATION_UPCOMING_METRIC:
            licenseStatus.expirationUpcoming = value > 0;
            licenseStatus.expiresIn = value;
            break;
          case LICENSE_TRIAL_METRIC:
            licenseStatus.trial = value > 0;
            licenseStatus.trialExpiresIn = value;
            break;
          case LICENSE_TRAFFIC_VIOLATION_UPCOMING_METRIC:
            licenseStatus.trafficViolation = value > 0;
            break;
          case LICENSE_USAGE_THRESHOLD_METRIC:
            licenseStatus.usageThresholdWarning = value > 0;
            licenseStatus.usageThreshold = value;
            break;
          default:
            break;
        }
      });
    });
    return licenseStatus;
  }, [metrics]);
};
export default useLicenseStatus;
